const getContinueUploadState = (state) => state.continueUpload;

export const selectShowContinueUpload = (state) => getContinueUploadState(state).showContinueUpload;
